import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalvarsService } from 'src/app/services/globalvars.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.css']
})
export class AddScenarioComponent implements OnInit {

  public pageId = 0;

  name = ''
  scenario = '{ "nextScenarioId": 0, "scenarioId": 0, "scenario": []}'
  department_id = 0;
  public departments: any[] = [];

  addurl: any;
  addpause: any
  addformid: any
  addformvalue: any
  addformclick: any
  addformsubmit: any

  scenarioItems: any[] = []


  constructor(
    private route: ActivatedRoute,
    private rest: RestService,
    private globalvar: GlobalvarsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getDepartments(tmpToken.accessToken)
      .then(value => {
        this.departments.push(value)
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }

  save() {
    if (this.department_id == 0) {
      return
    }
    if (!this.name) {
      return
    }
    
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    let scenario = {
      name: this.name,
      scenario: this.scenario,
      department_id: this.department_id
    }

    this.rest.postScenario(tmpToken.accessToken, scenario)
      .then(value => {
        this.router.navigateByUrl('/scenarios');
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }

  addUrl() {
    this.scenarioItems.push(
      {
        type: "URL",
        description: this.addurl,
        data: JSON.stringify({
          visitUrl: { uri: this.addurl, active: true }
        })
      }
    )
    this.generateScenarioJSON()
    this.addurl = ''
  }

  addPause() {
    this.scenarioItems.push(
      {
        type: "Pause",
        description: this.addpause,
        data: JSON.stringify({
          waitForTimeout: {
            timeout: this.addpause,
            active: true
          }
        })
      }
    )
    this.generateScenarioJSON()
    this.addpause = ''
  }

  addFormItem() {
    this.scenarioItems.push(
      {
        type: "Form Item",
        description: '(id : ' + this.addformid + ') ' + this.addformvalue,
        data: JSON.stringify({
          fillFormItem: {
            formItemId: this.addformid,
            formItemValue: this.addformvalue,
            active: true
          }
        })
      }
    )
    this.generateScenarioJSON()
    this.addformid = ''
    this.addformvalue = ''
  }

  addFormclick() {
    this.scenarioItems.push(
      {
        type: "Form click",
        description: this.addformclick,
        data: JSON.stringify({
          clickFormItem: {
            formItemId: this.addformclick,
            active: true
          }
        })
      }
    )
    this.generateScenarioJSON()
    this.addformclick = ''
  }

  addFormSubmit() {
    this.scenarioItems.push(
      {
        type: "Form click",
        description: this.addformsubmit,
        data: JSON.stringify({
          submitFormItem: {
            formItemId: this.addformsubmit,
            active: true
          }
        })
      }
    )
    this.generateScenarioJSON()
    this.addformclick = ''
  }


  remove(itemIndex: any) {
    this.scenarioItems.splice(itemIndex, 1)
    this.generateScenarioJSON()
  }

  generateScenarioJSON() {
    let scenarioStart = '{ \"nextScenarioId\": 0, \"scenarioId\": 0, \"scenario\": ['
    let scenarioEnd = ']}'


    let tmpScenarioItem: any = ''
    let i = 0
    for (let item of this.scenarioItems) {
      tmpScenarioItem += item.data
      if (i + 1 != this.scenarioItems.length) {
        tmpScenarioItem += ','
      }
      i++
    }

    let tmpScenarioObj = scenarioStart + tmpScenarioItem + scenarioEnd
    console.log(JSON.parse(tmpScenarioObj))
    this.scenario = tmpScenarioObj
  }
}
